var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.partnerClass},[(_vm.onEthosPartnerSite)?_c('ethos'):_vm._e(),_c('router-view'),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }